import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { Context, SpeechServiceConfig } from "./Exports";
export var SynthesisServiceType;

(function (SynthesisServiceType) {
  SynthesisServiceType[SynthesisServiceType["Standard"] = 0] = "Standard";
  SynthesisServiceType[SynthesisServiceType["Custom"] = 1] = "Custom";
})(SynthesisServiceType || (SynthesisServiceType = {}));

export var SynthesizerConfig = /*#__PURE__*/function () {
  function SynthesizerConfig(speechServiceConfig, parameters) {
    _classCallCheck(this, SynthesizerConfig);

    this.privSynthesisServiceType = SynthesisServiceType.Standard;
    this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new SpeechServiceConfig(new Context(null));
    this.privParameters = parameters;
  }

  _createClass(SynthesizerConfig, [{
    key: "parameters",
    get: function get() {
      return this.privParameters;
    }
  }, {
    key: "synthesisServiceType",
    get: function get() {
      return this.privSynthesisServiceType;
    },
    set: function set(value) {
      this.privSynthesisServiceType = value;
    }
  }, {
    key: "SpeechServiceConfig",
    get: function get() {
      return this.privSpeechServiceConfig;
    }
  }]);

  return SynthesizerConfig;
}();